module.exports = __webpack_public_path__ + "static/media/promotional_5.1fa4e83a.png";